import {Component, Input} from '@angular/core';
import {ISpecial} from '@api/models/specials/specials';
import {ImageService} from '@utils/services/image/image.service';

@Component({
  selector: 'app-special-card',
  templateUrl: './special-card.component.html',
  styleUrls: ['./special-card.component.scss'],
})
export class SpecialCardComponent {

  @Input() public special: ISpecial;
  public backgroundImage = ImageService.StaticImages.StartPage.headerBackgroundSmall;

}
